export default __webpack_public_path__ + "static/media/raffy_halim.36913f2a.jpg";